import React, { Component } from 'react';

class SocMed extends Component {
  render() {
    return (
      <section id="social_media">
        <div className="container">
          <div className="d-flex justify-content-center">
            <ul className="list-inline text-center">
              <li className="list-inline-item">
                <a href="#">
                  <img src="assets/facebook.png" alt="Facebook" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href="#">
                  <img src="assets/twitter.png" alt="Twitter" />    
                </a>
              </li>
              <li className="list-inline-item">
                <a href="#">
                  <img src="assets/instagram.png" alt="Instagram" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href="#">
                  <img src="assets/google-plus.png" alt="G+" />
                </a>
              </li>
            </ul>
          </div>
          <div className="d-flex justify-content-center">
            <p className="d-flex align-item-center social_media--desc">COPYRIGHT © 2018 DONASI MASJID ALL RIGHTS RESERVED</p>
          </div>
        </div>
      </section>
    )
  }
}

export default SocMed;



// WEBPACK FOOTER //
// ./src/components/SocMed.js